"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("../styles/App.css");
require("../styles/Timeline.css");
var _Tooltip = _interopRequireDefault(require("@mui/material/Tooltip"));
var _dayjs = _interopRequireDefault(require("dayjs"));
var _isoWeek = _interopRequireDefault(require("dayjs/plugin/isoWeek"));
require("dayjs/locale/fr");
var _react = require("react");
var _dist = require("package_ui_ihm/dist");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /**
* Nom : Timeline.js
* Description : Ce fichier contient la définition du composant Timeline 
*               Ce composant affiche une timeline avec les traitements réalisés sur le produit client
* Date de création : 22 janvier 2026
*/ /* CSS et assets*/ /* Bibliothèques et composants */ // <-- importe la locale
/* Hook */ // définit 'fr' comme locale globale
_dayjs["default"].locale('fr');
_dayjs["default"].extend(_isoWeek["default"]);
var customParseFormat = require("dayjs/plugin/customParseFormat");
_dayjs["default"].extend(customParseFormat);

/**
* Timeline : ce composant affiche une timeline avec les traitements réalisés sur le produit client
*
* Type : composant 
*
* Parametres : 
*  - treatmentOccurences -- liste des traitements réalisés sur le produit client
*  - calendarDate -- date des données à afficher 
*  - optionDate -- option de filtrage de la date (par jour, semaine, mois ou année)
*/
function Timeline(_ref) {
  var treatmentOccurences = _ref.treatmentOccurences,
    calendarDate = _ref.calendarDate,
    optionDate = _ref.optionDate;
  // Constantes
  var text_small = 10;
  var text_medium = 15;
  var text_large = 20;
  var legend_y = 40;
  var legend_rect_w = 50;
  var legend_rect_h = 30;
  var timeline_heigth = 60;

  // Define useState hooks
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    filteredTreatmentOccurences = _useState2[0],
    setFilteredTreatmentOccurences = _useState2[1];
  var _useState3 = (0, _react.useState)(1300),
    _useState4 = _slicedToArray(_useState3, 2),
    width = _useState4[0],
    setWidth = _useState4[1];
  var _useState5 = (0, _react.useState)((0, _dayjs["default"])()),
    _useState6 = _slicedToArray(_useState5, 2),
    date = _useState6[0],
    setDate = _useState6[1];
  var _useState7 = (0, _react.useState)((0, _dayjs["default"])()),
    _useState8 = _slicedToArray(_useState7, 2),
    dateStart = _useState8[0],
    setDateStart = _useState8[1];
  var _useState9 = (0, _react.useState)((0, _dayjs["default"])()),
    _useState0 = _slicedToArray(_useState9, 2),
    dateEnd = _useState0[0],
    setDateEnd = _useState0[1];
  var _useState1 = (0, _react.useState)(1200),
    _useState10 = _slicedToArray(_useState1, 2),
    maxtime = _useState10[0],
    setMaxtime = _useState10[1];
  var _useState11 = (0, _react.useState)([]),
    _useState12 = _slicedToArray(_useState11, 2),
    treatmentsData = _useState12[0],
    setTreatmentsData = _useState12[1];

  // Define useScreenWidth hooks
  var screenWidth = (0, _dist.useScreenWidth)();

  // Fonctions 
  function updateDates() {
    // Date by day
    if (optionDate === 1) {
      var dateTemp = calendarDate.set('hour', 0).set('minute', 0).set('second', 0).set('millisecond', 0);
      setDate(dateTemp);
      setDateStart(dateTemp);
      setDateEnd(dateTemp.add(1, 'day'));
    }
    // Date by week
    else if (optionDate === 2) {
      var _dateTemp = calendarDate.isoWeekday(1).set('hour', 0).set('minute', 0).set('second', 0).set('millisecond', 0);
      setDate(_dateTemp);
      setDateStart(_dateTemp);
      setDateEnd(_dateTemp.add(7, 'day'));
    }
    // Date by month
    else if (optionDate === 3) {
      var _dateTemp2 = calendarDate.set('date', 1).set('hour', 0).set('minute', 0).set('second', 0).set('millisecond', 0);
      setDate(_dateTemp2);
      setDateStart(_dateTemp2);
      setDateEnd(_dateTemp2.add(1, 'month'));
    }
    // Date by year
    else {
      var _dateTemp3 = calendarDate.set('month', 0).set('date', 1).set('hour', 0).set('minute', 0).set('second', 0).set('millisecond', 0);
      setDate(_dateTemp3);
      setDateStart(_dateTemp3);
      setDateEnd(_dateTemp3.add(1, 'year'));
    }
  }
  function updateFilteredTreatmentOccurences() {
    setFilteredTreatmentOccurences(treatmentOccurences.filter(function (treatmentOccurence) {
      return (0, _dayjs["default"])(treatmentOccurence['end_date'], 'YYYY-MM-DD HH:mm:ss').isBefore(dateStart) === false && (0, _dayjs["default"])(treatmentOccurence['start_date'], 'YYYY-MM-DD HH:mm:ss').isAfter(dateEnd) === false;
    }));
  }
  function createSvgData() {
    // Compute maxtime
    setMaxtime(new Date(dateEnd) - new Date(dateStart));
    // Compute trials data
    var trials_data = [];
    filteredTreatmentOccurences.forEach(function (treatment) {
      var maxtime = new Date(dateEnd) - new Date(dateStart);
      var x1;
      if ((0, _dayjs["default"])(treatment['start_date'], 'YYYY-MM-DD HH:mm:ss').isBefore(dateStart)) {
        x1 = 0;
      } else {
        x1 = (new Date(treatment['start_date']) - new Date(dateStart)) / maxtime * (width - 100);
      }
      var x2;
      if ((0, _dayjs["default"])(treatment['end_date'], 'YYYY-MM-DD HH:mm:ss').isAfter(dateEnd)) {
        x2 = width - 100;
      } else {
        x2 = (new Date(treatment['end_date']) - new Date(dateStart)) / maxtime * (width - 100);
      }
      var w = x2 - x1;
      var phase_logs_data = [];
      treatment.phase_logs.forEach(function (phaseLog) {
        if ((0, _dayjs["default"])(phaseLog['end_date'], 'YYYY-MM-DD HH:mm:ss').isBefore(dateStart) === false && (0, _dayjs["default"])(phaseLog['start_date'], 'YYYY-MM-DD HH:mm:ss').isAfter(dateEnd) === false) {
          var xx1;
          if ((0, _dayjs["default"])(phaseLog['start_date'], 'YYYY-MM-DD HH:mm:ss').isBefore(dateStart)) {
            xx1 = 0;
          } else {
            xx1 = (new Date(phaseLog['start_date']) - new Date(dateStart)) / maxtime * (width - 100);
          }
          var xx2;
          if ((0, _dayjs["default"])(phaseLog['end_date'], 'YYYY-MM-DD HH:mm:ss').isAfter(dateEnd)) {
            xx2 = width - 100;
          } else {
            xx2 = (new Date(phaseLog['end_date']) - new Date(dateStart)) / maxtime * (width - 100);
          }
          var ww = xx2 - xx1;
          phase_logs_data.push({
            'start_date': phaseLog['start_date'],
            'end_date': phaseLog['end_date'],
            'x1': xx1,
            'x2': xx2,
            'w': ww
          });
        }
      });
      trials_data.push({
        'name': treatment['treatment_param']['name'],
        'start_date': treatment['start_date'],
        'end_date': treatment['end_date'],
        'phase_logs_data': phase_logs_data,
        'x1': x1,
        'x2': x2,
        'w': w
      });
    });
    setTreatmentsData(trials_data);
  }

  // Define useEffect hooks
  (0, _react.useEffect)(function () {
    updateDates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [calendarDate, optionDate]);
  (0, _react.useEffect)(function () {
    updateFilteredTreatmentOccurences();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date]);
  (0, _react.useEffect)(function () {
    createSvgData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteredTreatmentOccurences, screenWidth]);
  (0, _react.useEffect)(function () {
    setWidth(screenWidth * 0.75);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [screenWidth]);

  // Render component 
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "margin-bottom margin-top",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
      width: width,
      height: 200,
      children: [screenWidth > 600 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
          x: 0,
          y: legend_y,
          textAnchor: "start",
          fontSize: text_medium,
          children: "L\xE9gende :"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          x: 100,
          y: legend_y - 25,
          width: legend_rect_w,
          height: legend_rect_h,
          className: "treatment-off",
          stroke: "black",
          strokeWidth: 1
        }), optionDate < 3 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
            x: 170,
            y: legend_y,
            textAnchor: "start",
            fontSize: text_small,
            children: "Traitement en veille"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            x: 275,
            y: legend_y - 25,
            width: legend_rect_w,
            height: legend_rect_h,
            className: "treatment-on",
            stroke: "black",
            strokeWidth: 1
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
            x: 345,
            y: legend_y,
            textAnchor: "start",
            fontSize: text_small,
            children: "Traitement en cours"
          })]
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
            x: 170,
            y: legend_y,
            textAnchor: "start",
            fontSize: text_small,
            children: "Traitement"
          })
        })]
      }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
          x: 0,
          y: legend_y,
          textAnchor: "start",
          fontSize: text_medium,
          children: "L\xE9gende :"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          x: 75,
          y: legend_y - 15,
          width: legend_rect_w / 2,
          height: legend_rect_h / 2,
          className: "treatment-off",
          stroke: "black",
          strokeWidth: 1
        }), optionDate < 3 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
            x: 115,
            y: legend_y,
            textAnchor: "start",
            fontSize: text_small,
            children: "En veille"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            x: 180,
            y: legend_y - 15,
            width: legend_rect_w / 2,
            height: legend_rect_h / 2,
            className: "treatment-on",
            stroke: "black",
            strokeWidth: 1
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
            x: 210,
            y: legend_y,
            textAnchor: "start",
            fontSize: text_small,
            children: "En cours"
          })]
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
            x: 170,
            y: legend_y,
            textAnchor: "start",
            fontSize: text_small,
            children: "Traitement"
          })
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        x: 0,
        y: 100,
        width: width - 50,
        height: timeline_heigth,
        fill: "white",
        stroke: "black",
        strokeWidth: 2
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
        x1: width - 50,
        y1: 90,
        x2: width,
        y2: 130,
        stroke: "black",
        strokeWidth: 2
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
        x1: width - 50,
        y1: 170,
        x2: width,
        y2: 130,
        stroke: "black",
        strokeWidth: 2
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
        x1: width - 50,
        y1: 90,
        x2: width - 50,
        y2: 170,
        stroke: "black",
        strokeWidth: 2
      }), optionDate === 1 ? screenWidth > 850 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
          x: 50,
          y: 85,
          textAnchor: "middle",
          fontSize: text_small,
          children: "00:00:00"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
          x: 50 + 1 * ((width - 100) / 12),
          y: 85,
          textAnchor: "middle",
          fontSize: text_small,
          children: "02:00:00"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
          x: 50 + 2 * ((width - 100) / 12),
          y: 85,
          textAnchor: "middle",
          fontSize: text_small,
          children: "04:00:00"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
          x: 50 + 3 * ((width - 100) / 12),
          y: 85,
          textAnchor: "middle",
          fontSize: text_small,
          children: "06:00:00"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
          x: 50 + 4 * ((width - 100) / 12),
          y: 85,
          textAnchor: "middle",
          fontSize: text_small,
          children: "08:00:00"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
          x: 50 + 5 * ((width - 100) / 12),
          y: 85,
          textAnchor: "middle",
          fontSize: text_small,
          children: "10:00:00"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
          x: 50 + 6 * ((width - 100) / 12),
          y: 85,
          textAnchor: "middle",
          fontSize: text_small,
          children: "12:00:00"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
          x: 50 + 7 * ((width - 100) / 12),
          y: 85,
          textAnchor: "middle",
          fontSize: text_small,
          children: "14:00:00"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
          x: 50 + 8 * ((width - 100) / 12),
          y: 85,
          textAnchor: "middle",
          fontSize: text_small,
          children: "16:00:00"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
          x: 50 + 9 * ((width - 100) / 12),
          y: 85,
          textAnchor: "middle",
          fontSize: text_small,
          children: "18:00:00"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
          x: 50 + 10 * ((width - 100) / 12),
          y: 85,
          textAnchor: "middle",
          fontSize: text_small,
          children: "20:00:00"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
          x: 50 + 11 * ((width - 100) / 12),
          y: 85,
          textAnchor: "middle",
          fontSize: text_small,
          children: "22:00:00"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
          x: width - 50,
          y: 85,
          textAnchor: "middle",
          fontSize: text_small,
          children: "23:59:59"
        })]
      }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
          x: 50,
          y: 85,
          textAnchor: "middle",
          fontSize: text_small,
          children: "00:00:00"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
          x: 50 + 3 * ((width - 100) / 12),
          y: 85,
          textAnchor: "middle",
          fontSize: text_small,
          children: "06:00:00"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
          x: 50 + 6 * ((width - 100) / 12),
          y: 85,
          textAnchor: "middle",
          fontSize: text_small,
          children: "12:00:00"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
          x: 50 + 9 * ((width - 100) / 12),
          y: 85,
          textAnchor: "middle",
          fontSize: text_small,
          children: "18:00:00"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
          x: width - 50,
          y: 85,
          textAnchor: "middle",
          fontSize: text_small,
          children: "23:59:59"
        })]
      }) : optionDate === 2 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
          x: 50,
          y: 85,
          textAnchor: "middle",
          fontSize: text_small,
          children: "Lun"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
          x: 50 + 1 * ((width - 100) / 7),
          y: 85,
          textAnchor: "middle",
          fontSize: text_small,
          children: "Mar"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
          x: 50 + 2 * ((width - 100) / 7),
          y: 85,
          textAnchor: "middle",
          fontSize: text_small,
          children: "Mer"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
          x: 50 + 3 * ((width - 100) / 7),
          y: 85,
          textAnchor: "middle",
          fontSize: text_small,
          children: "Jeu"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
          x: 50 + 4 * ((width - 100) / 7),
          y: 85,
          textAnchor: "middle",
          fontSize: text_small,
          children: "Ven"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
          x: 50 + 5 * ((width - 100) / 7),
          y: 85,
          textAnchor: "middle",
          fontSize: text_small,
          children: "Sam"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
          x: 50 + 6 * ((width - 100) / 7),
          y: 85,
          textAnchor: "middle",
          fontSize: text_small,
          children: "Dim"
        })]
      }) : optionDate === 3 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
          x: 50,
          y: 85,
          textAnchor: "middle",
          fontSize: text_small,
          children: "1"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
          x: 50 + (new Date(date.set('date', 5)) - new Date(dateStart)) / maxtime * (width - 100),
          y: 85,
          textAnchor: "middle",
          fontSize: text_small,
          children: "5"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
          x: 50 + (new Date(date.set('date', 10)) - new Date(dateStart)) / maxtime * (width - 100),
          y: 85,
          textAnchor: "middle",
          fontSize: text_small,
          children: "10"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
          x: 50 + (new Date(date.set('date', 15)) - new Date(dateStart)) / maxtime * (width - 100),
          y: 85,
          textAnchor: "middle",
          fontSize: text_small,
          children: "15"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
          x: 50 + (new Date(date.set('date', 20)) - new Date(dateStart)) / maxtime * (width - 100),
          y: 85,
          textAnchor: "middle",
          fontSize: text_small,
          children: "20"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
          x: 50 + (new Date(date.set('date', 25)) - new Date(dateStart)) / maxtime * (width - 100),
          y: 85,
          textAnchor: "middle",
          fontSize: text_small,
          children: "25"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
          x: width - 50,
          y: 85,
          textAnchor: "middle",
          fontSize: text_small,
          children: date.endOf('month').format('DD')
        })]
      }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
          x: 50,
          y: 85,
          textAnchor: "middle",
          fontSize: text_small,
          children: "01/01"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
          x: 50 + 1 * ((width - 100) / 6),
          y: 85,
          textAnchor: "middle",
          fontSize: text_small,
          children: "01/03"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
          x: 50 + 2 * ((width - 100) / 6),
          y: 85,
          textAnchor: "middle",
          fontSize: text_small,
          children: "01/05"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
          x: 50 + 3 * ((width - 100) / 6),
          y: 85,
          textAnchor: "middle",
          fontSize: text_small,
          children: "01/07"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
          x: 50 + 4 * ((width - 100) / 6),
          y: 85,
          textAnchor: "middle",
          fontSize: text_small,
          children: "01/09"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
          x: 50 + 5 * ((width - 100) / 6),
          y: 85,
          textAnchor: "middle",
          fontSize: text_small,
          children: "01/11"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
          x: width - 50,
          y: 85,
          textAnchor: "middle",
          fontSize: text_small,
          children: "31/12"
        })]
      }), treatmentsData && treatmentsData.length > 0 ? treatmentsData.map(function (treatmentData, idx) {
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip["default"], {
            title: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                children: treatmentData['name']
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
                children: ["D\xE9but : ", treatmentData['start_date'], " - Fin : ", treatmentData['end_date']]
              })]
            }),
            arrow: true,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              style: {
                cursor: 'pointer'
              },
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                x: treatmentData['x1'] + 50,
                y: 100,
                width: treatmentData['w'],
                height: timeline_heigth,
                className: "treatment-off",
                stroke: "black",
                strokeWidth: 1
              })
            })
          }, idx), optionDate < 3 ? treatmentData['phase_logs_data'].map(function (phaseLogData, index) {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip["default"], {
                title: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                    children: treatmentData['name']
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
                    children: ["D\xE9but : ", treatmentData['start_date'], " - Fin : ", treatmentData['end_date']]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
                    children: ["Phase active : ", phaseLogData['start_date'], " - ", phaseLogData['end_date']]
                  })]
                }),
                arrow: true,
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                  style: {
                    cursor: 'pointer'
                  },
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                    x: phaseLogData['x1'] + 50,
                    y: 100,
                    width: phaseLogData['w'],
                    height: timeline_heigth,
                    className: "treatment-on",
                    stroke: "black",
                    strokeWidth: 1
                  })
                })
              }, index)
            }, index);
          }) : null]
        }, idx);
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
        x: width / 2,
        y: 135,
        textAnchor: "middle",
        fontSize: text_medium,
        children: "Aucun traitement sur cette p\xE9riode."
      })]
    })
  });
}
var _default = exports["default"] = Timeline;